import { useDispatch } from "react-redux";

import {
  getListData,
  deleteConditionData,
  createConditionData,
  editConditionData,
  getConstantsData,
  getViewConditionData,
  clearDeleteConditionState,
  clearListState,
  clearConstantsState,
  clearCreateConditionState,
  clearEditConditionState,
  clearViewConditionState,
  payloadSubAffDealsV2List,
	getFilterCreatorData,
  getSubAffDealData,
  clearSubAffDealState,
  getSubAffDealLevelsData,
  clearSubAffDealLevelsState,
  getSubAffDealListData,
  clearSubAffDealListState,
  updateSubAffDealData,
  clearUpdateSubAffDealState,
} from "./index";


export const useSubAffDealsV2 = () => {
  const dispatch = useDispatch();

  const getList = (data: payloadSubAffDealsV2List) => dispatch(getListData(data));
  const clearList = () => dispatch(clearListState());

  const deleteCondition = (data: any) => dispatch(deleteConditionData(data));
  const clearDeleteCondition = () => dispatch(clearDeleteConditionState());

  const getConstants = () => dispatch(getConstantsData());
  const clearConstants = () => dispatch(clearConstantsState());

  const createCondition = (data: any) => dispatch(createConditionData(data));
  const clearCreateCondition = () => dispatch(clearCreateConditionState());

  const getViewCondition = (id: string) => dispatch(getViewConditionData(id));
  const clearViewCondition = () => dispatch(clearViewConditionState());

  const editCondition = (data: any) => dispatch(editConditionData(data));
  const clearEditCondition = () => dispatch(clearEditConditionState());

	const getFilterCreator = (data: any) => dispatch(getFilterCreatorData(data));

  const getSubAffDeal = (id: string) => dispatch(getSubAffDealData(id));
  const clearSubAffDeal = () => dispatch(clearSubAffDealState());

  const getSubAffDealLevels = (id: string) => dispatch(getSubAffDealLevelsData(id));
  const clearSubAffDealLevels = () => dispatch(clearSubAffDealLevelsState());

  const getSubAffDealList = (data: any) => dispatch(getSubAffDealListData(data));
  const clearSubAffDealList = () => dispatch(clearSubAffDealListState());

  const updateSubAffDeal = (data: any) => dispatch(updateSubAffDealData(data));
  const clearUpdateSubAffDeal = () => dispatch(clearUpdateSubAffDealState());

  return {
    getList,
    clearList,
    deleteCondition,
    clearDeleteCondition,
    getConstants,
    clearConstants,
    createCondition,
    clearCreateCondition,
    getViewCondition,
    clearViewCondition,
    editCondition,
    clearEditCondition,
	  getFilterCreator,
    getSubAffDeal,
    clearSubAffDeal,
    getSubAffDealLevels,
    clearSubAffDealLevels,
    getSubAffDealList,
    clearSubAffDealList,
    updateSubAffDeal,
    clearUpdateSubAffDeal,
  }
}
